/* eslint-disable no-console */
import { registerLegacySalvoLiteComponent } from '@eastsideco/salvo-ts';
import HcSticky from 'hc-sticky';

class StickyOnScroll {
    constructor(theme, elem) {
        this._theme = theme;
        this._elem = elem;
        this._options = Object.assign({
            top: 0,
            bottomEnd: 0,
            stickTo: elem.closest('[data-sticky-on-scroll-container]') || elem.closest('section')
        }, JSON.parse(elem.dataset.sticky || '{}'));
    }

    onInit() {
        if (window.innerWidth > 768) {
            const sticky = new HcSticky(this._elem, this._options);
            document.addEventListener('update-sticky', () => {
                sticky.update();
            });
        }
    }
}

export default registerLegacySalvoLiteComponent({
    component: StickyOnScroll,
    selector: '[data-sticky-on-scroll]', // Required
});
